import React, { useEffect, useState, useCallback, useMemo } from "react";
import URI from "urijs";
import generateId from "logic/generateId";
import { Spinner } from "components/common";
import connect from "stores/connect";
import Store from "logic/local-storage/Store";
import {
  LOGIN_INITIALIZED_STATE,
  LOGIN_INITIALIZING_STATE,
  LOGIN_TRANSITIONING_STATE
} from "logic/authentication/constants";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import OidcCallback from "./OidcCallback";
import { OidcConfigurationActions, OidcConfigurationStore } from "./OidcConfigurationStore";
import { OidcSessionStore } from "./OidcSessionStore";
import OidcGenericLoginLink from "./OidcGenericLoginLink";
import OidcRoutes from "../Routes";
import OktaLoginForm from "../okta/OktaLoginForm";
const OidcLogin = ({
  configuration = void 0,
  configurationError = void 0,
  isLoading,
  onErrorChange,
  setLoginFormState
}) => {
  const uri = useMemo(() => new URI(window.location.href), []);
  const configNotLoaded = isLoading || !configuration;
  useEffect(() => {
    OidcConfigurationActions.getConfig();
  }, []);
  useEffect(() => {
    if (configurationError) {
      throw configurationError;
    }
  }, [configurationError]);
  const isCallbackUrl = useCallback(() => uri.path() === OidcRoutes.AUTH_CALLBACK, [uri]);
  const generateNonce = (redirectTo = uri.resource()) => ({
    state: generateId(),
    redirectTo
  });
  const [nonce, setNonce] = useState(() => {
    var _a;
    try {
      if (isCallbackUrl()) {
        return (_a = Store.sessionGet("nonce")) != null ? _a : generateNonce();
      }
    } catch (_e) {
      return generateNonce();
    }
    return generateNonce();
  });
  const regenerateNonce = () => {
    setNonce((prevNonce) => generateNonce(prevNonce.redirectTo));
  };
  useEffect(() => {
    Store.sessionSet("nonce", nonce);
  }, [nonce]);
  useEffect(() => {
    if (configNotLoaded) {
      setLoginFormState(LOGIN_INITIALIZING_STATE);
    } else if (isCallbackUrl()) {
      setLoginFormState(LOGIN_TRANSITIONING_STATE);
    } else {
      setLoginFormState(LOGIN_INITIALIZED_STATE);
    }
  }, [configNotLoaded, isCallbackUrl, setLoginFormState]);
  if (configNotLoaded) {
    return /* @__PURE__ */ React.createElement("p", { className: "loading-text" }, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading, please wait...", delay: 0 }));
  }
  if (isCallbackUrl()) {
    return /* @__PURE__ */ React.createElement(
      OidcCallback,
      {
        configuration,
        nonce,
        onErrorChange,
        params: uri.query(true),
        regenerateNonce
      }
    );
  }
  return configuration.oauth_type === OKTA_TYPE_KEY ? /* @__PURE__ */ React.createElement(OktaLoginForm, { checkSession: true, configuration, nonce }) : /* @__PURE__ */ React.createElement(OidcGenericLoginLink, { configuration, nonce });
};
export default connect(
  OidcLogin,
  {
    configuration: OidcConfigurationStore,
    oidcSession: OidcSessionStore
  },
  ({ configuration, oidcSession, ...props }) => ({
    ...props,
    configuration: configuration.configuration,
    configurationError: configuration.error,
    isLoading: oidcSession.isLoading
  })
);
